import { useRentalManagerAccountViewZrmListingsWebApiHandler_applications } from '@zg-rentals/ts-rental-manager-api-client-react-query';

import type { ListingAlias } from '@zg-rentals/ts-rental-manager-api-client';
import type { RentalManagerAccountViewZrmListingsWebApiHandler_applications_Options } from '@zg-rentals/ts-rental-manager-api-client-react-query';

export const useGetListingApplications = (
  listingAlias: ListingAlias,
  options: Partial<RentalManagerAccountViewZrmListingsWebApiHandler_applications_Options> = {},
) => {
  const { data, error, isFetching } = useRentalManagerAccountViewZrmListingsWebApiHandler_applications(
    { listingAlias },
    {
      ...options,
      enabled: Boolean(listingAlias) && (options.enabled ?? true),
      meta: {
        tags: ['getListingApplications', listingAlias],
        context: {
          api: 'useRentalManagerAccountViewZrmListingsWebApiHandler_applications',
          details: 'useGetListingApplications',
        },
      },
    },
  );

  return { data, isFetching, error };
};
